<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
            <b-card header="<i class='fa fa-star'></i> Detail Posko">
                <button @click="showModal" class="btn btn-success">Setor Donasi</button>
                <br>
                <div v-if="isLoading" > 
                    <center>
                        <v-pulse></v-pulse>
                    </center>
                </div>
                <div v-else>
                    <b-img fluid 
                        class="imageFile" 
                        center 
                        :src="'https://res.cloudinary.com/wahyupermadie/image/fetch/c_fill,g_auto:face,h_120,w_120,fl_force_strip.progressive/f_webp/https://hackathon.futnet.id/posko/'+poskos.foto"
                        alt="center image">
                    </b-img>
                    <br>
                    <b-row>
                        <b-col sm="4" center>
                            <b-card header="<i class='fa fa-star'></i> Detail Posko">
                                <b-form enctype="multipart/form-data">
                                    <b-form-group
                                        label="Nama Pemilik"
                                        label-for="nama">
                                        <b-form-input disabled v-model="poskos.user_name"  required id="nama" type="text" placeholder="Nama Adik Asuh" autocomplete="Nama"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="No Telepon"
                                        label-for="tanggallahir">
                                        <b-form-input 
                                        disabled
                                        v-model="poskos.phone"
                                        id="notlp" 
                                        type="text" 
                                        placeholder="No Telepon" 
                                        required 
                                        autocomplete="notlp">
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Alamat"
                                        label-for="alamat">
                                        <textarea 
                                            disabled
                                            v-model="poskos.address"
                                            required 
                                            class="form-control" 
                                            placeholder="Alamat Posko" 
                                            rows="5" 
                                            id="alamat">
                                        </textarea>
                                    </b-form-group>
                                    <b-form-group
                                        label="Deskripsi"
                                        label-for="deksripsi"> 
                                        <textarea disabled v-model="poskos.deskripsi" required class="form-control" placeholder="Deskripsi Adik Asuh" rows="5" id="deskripsi"></textarea>
                                    </b-form-group>
                                </b-form>
                            </b-card>
                        </b-col>
                        <b-col sm="4">
                            <b-card header="<i class='fa fa-star'></i> Detail Support">
                                <b-card v-for="(value,index) in poskos.funding" :key="index">
                                    {{value.title}} - <b> {{value.admin_name}} </b>
                                </b-card>
                            </b-card>
                        </b-col>
                        <b-col sm="4">
                            <b-card header="<i class='fa fa-star'></i> Detail Donasi">
                                <b-card header="<i class='fa fa-star'></i> Sandang">
                                    <b-card v-for="(value,index) in poskos.logistik.sandang" :key="index">
                                        {{value.id}} - {{value.name}}
                                    </b-card>
                                </b-card>
                                <b-card header="<i class='fa fa-star'></i> Pangan">
                                    <b-card v-for="(value,index) in poskos.logistik.pangan" :key="index">
                                        {{value.id}} - {{value.name}}
                                    </b-card>
                                </b-card>
                                <b-card header="<i class='fa fa-star'></i> Papan">
                                    <b-card v-for="(value,index) in poskos.logistik.papan" :key="index">
                                        {{value.id}} - {{value.name}}
                                    </b-card>
                                </b-card>
                                <b-card header="<i class='fa fa-star'></i> Mck">
                                    <b-card v-for="(value,index) in poskos.logistik.mck" :key="index">
                                        {{value.id}} - {{value.name}}
                                    </b-card>
                                </b-card>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
            </b-card>
        </b-col><!--/.col-->
      </b-row><!--/.row-->
    </div>
    <b-modal title="Penyerahan Donasi" class="modal-primary" v-model="isModalVisible">
        <b-form enctype="multipart/form-data">
            <b-form-group
                label="Pilih Funding"
                label-for="fundings">
                <v-select v-model="selected" :options="fundings"></v-select>
            </b-form-group>
            <b-form-group
                label="Tanggal Penyerahan"
                label-for="tanggalmulai">
                <b-form-input
                id="tanggallahir" 
                type="date" 
                placeholder="Tanggal Penyerahan" 
                required 
                autocomplete="tanggallahir">
                </b-form-input>
            </b-form-group>
            <b-form-group
                label="Deskripsi Penyerahaan"
                label-for="deskripsi">
                <textarea  required class="form-control" placeholder="Deskripsi Penyerahan" rows="5" id="deskripsi"></textarea>
            </b-form-group>
            <b-form-group>
                <b-input-group class="mb-4">
                  <b-form-file name="filefunding" id="filefunding"  placeholder="Choose foto penyerahan..."></b-form-file>
                </b-input-group>
            </b-form-group>
        </b-form>
      </b-modal>
  </div>
</template>

<script>
import router from '@/router/index'
import axios from 'axios'
import {getCache,storedCache} from '@/cache'
import constant from '../../utils/constant.js';
export default {
  data () {
    return {
        isLoading: true,
        isModalVisible: false,
        selected : null,
        funding : {},
        fundings:[],
        poskos:{},
    }
  },
  mounted() {
    
  },
  created(){
     this.getPosko()
     this.getFunding()
  },
  beforeMount()
  {
    // this.initMap()
  },
  watch: {
    '$route' : 'getpayments'
  },
  methods:{
        openSpinner()
        {
            this.isLoading = true
        },
        closeSpinner()
        {
            this.isLoading = false
        },
        getPosko()
        {
            this.openSpinner()
            const token = localStorage.getItem(`user_token`);
            const community_id = localStorage.getItem('user_id');
            axios.get(constant._BASE_URL+"posko/"+this.$route.params.id,{
                headers:{
                    'Content-type': 'application/json',
                    'Authorization' : 'Bearer '+token,
                }
            }).then(response =>{
                storedCache(`posko`+community_id, response.data)
                this.poskos = getCache(`posko`+community_id)
                console.log(this.poskos)
                this.closeSpinner()
            }).catch(error => {
                console.log(error)
                this.poskos = getCache(`posko`+community_id)
                this.closeSpinner()
            });
        },
        getFunding()
        {
                const token = localStorage.getItem(`user_token`);
                const community_id = localStorage.getItem('user_id');
                axios.get(constant._BASE_URL+"funding",{ 
                    headers: {
                    'Content-type': 'application/json',
                    'Authorization' : 'Bearer '+token,
                    }
                }).then(response => {
                        var funding = response.data
                        storedCache('funding'+community_id, funding)

                        var fundings = getCache('funding'+community_id)
                        for(let i=0;i<fundings.length;i++)
                        {
                            let data = {
                                'label' : fundings[i]['title'],
                                'value' : fundings[i]['id']
                            }
                            this.fundings.push(data)
                        }

                }).catch(error => {
                        alert(error)
                        var fundings = getCache('funding'+community_id)
                        for(let i=0;i<fundings.length;i++)
                        {
                            let data = {
                                'label' : fundings[i]['title'],
                                'value' : fundings[i]['id']
                            }
                            this.fundings.push(data)
                        }
                });
            
        },
        showModal() {
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },
    }
}
</script>
<style scoped>
.imageFile {
  height: 150px;
}
.imageHome {
  width: 30%;
  display: inline-block;
  margin-left: 0dp;
  margin-right: 0dp;
}
#myMap {
    height:400px;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/posko/Posko.vue